import React, { useState } from 'react';
import { PageNavigation, NeuroMessage } from '@ignitesales/neuro-application';
import { getRandomIndex } from '@ignitesales/neuro-application/src/neuro-guide/utils';
import Footer from "../Footer.jsx";

const SurveyPage = ({ className, renderQuestionGroups }) => {
  let currentIndex;

  const backgroundImages = Array.from(Array(12).keys());

  const [imgIdx, setImgIdx] = useState(
    getRandomIndex(currentIndex, backgroundImages)
  );

  React.useEffect(() => {
    setImgIdx(getRandomIndex(currentIndex, backgroundImages));
  }, [location.pathname]);

  return (
    <div className={className} style={{'background-image': `url(/classpath/assets/images/survey-image-${imgIdx}.jpg)`}}>
      <div className="questionGroups clear">{ renderQuestionGroups() }</div>
      <Footer>
        <PageNavigation
          innerNextBtn={<NeuroMessage id="nav.next" />}
          innerPrevBtn={<NeuroMessage id="nav.prev" />}
        />
      </Footer>
    </div>
  );
};

export default SurveyPage;
